export const footer = {
  en: {
    copyright: '© {year} Charlie Fonseca. All rights reserved.'
  },
  pt: {
    copyright: '© {year} Charlie Fonseca. Todos os direitos reservados.'
  }
};